// extracted by mini-css-extract-plugin
export default {"switcherIcon":"SwitcherIcon_switcherIcon__K0IOM","box":"SwitcherIcon_box__SILpa"};